import React from 'react'

import CountriesSprite from './country-flags/countries-flags-sprite.svg'

const countryFlagWrapperStyle: React.CSSProperties = {
    display: 'flex',
    borderRadius: '50%',
    width: 16,
    height: 16,
    flexShrink: 0,
    overflow: 'hidden',
}

const CountryIcon: React.FC<{ flag?: string }> = ({ flag }) => {
    return (
        <div style={countryFlagWrapperStyle}>
            <svg
                width="16px"
                height="16px"
                viewBox="0 0 64 64"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <use xlinkHref={`${CountriesSprite}#Rounded=${flag || 'unknown'}`}></use>
            </svg>
        </div>
    )
}

export default CountryIcon
